import { useIntl } from 'react-intl';

// MUI
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';

// common
import CheckBoxSchema from 'common/SchemaForm/element/checkbox/CheckBoxSchema';
import { type CommonRole } from 'modules/account/services/useGetRoles';

interface Props {
  role: CommonRole;
  onSelectSystemRole: (roleId: string, isChecked: boolean) => void;

  /**
   * được sử dụng đến thực hiện khi chỉnh sửa
   */
  isChecked?: boolean;
  viewOnly?: boolean;
}

const SystemAdminRoleType = (props: Props) => {
  const { role, onSelectSystemRole, isChecked, viewOnly } = props;
  const { formatMessage } = useIntl();

  return (
    <Tooltip title={role.description}>
      <Box>
        <Typography variant="subtitle1">{role.name}</Typography>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            fontSize: '0.8em',
          }}
        >
          <Typography>{formatMessage({ id: 'account.permissionType' })}:</Typography>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Box sx={{ marginRight: '8px' }}>
              <Typography>
                {role.parentId === null
                  ? formatMessage({ id: 'account.roles.type.static' })
                  : formatMessage({ id: 'account.roles.type.dynamic' })}
              </Typography>
            </Box>
            <Box sx={{ width: '24px' }}>
              <CheckBoxSchema
                sx={{
                  paddingRight: '10px',
                  width: '24px',
                  height: '24px',
                }}
                disabled={Boolean(viewOnly)}
                checked={isChecked}
                onChange={(_e, checked) => onSelectSystemRole(role.id, checked)}
              />
            </Box>
          </Box>
        </Box>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            fontSize: '0.8em',
          }}
        >
          <Typography>{formatMessage({ id: 'account.appliedUnit' })}:</Typography>
          <Box sx={{ marginRight: '24px' }}>
            <Typography>{formatMessage({ id: 'all' })}</Typography>
          </Box>
        </Box>
      </Box>
    </Tooltip>
  );
};

export default SystemAdminRoleType;
